import create from 'zustand';
import { persist } from 'zustand/middleware';

// `classic` keeps the logo in the header, above the side menu; `new` docks the side menu in a
// full-height column that carries the logo, with the header beside it.
export type LayoutVersion = 'classic' | 'new';

type LayoutVersionState = {
  version: LayoutVersion;
  // Whether the person has already seen the announcement of the new layout, whatever they chose.
  announcementSeen: boolean;
  setNewLayout: (enabled: boolean) => void;
  dismissAnnouncement: () => void;
};

export const useLayoutVersionStore = create(
  persist<LayoutVersionState>(
    (set) => {
      const setNewLayout = (enabled: boolean) => {
        set((state) => ({
          ...state,
          version: enabled ? `new` : `classic`,
          announcementSeen: true,
        }));
      };

      const dismissAnnouncement = () => {
        set((state) => ({ ...state, announcementSeen: true }));
      };

      return {
        version: `classic`,
        announcementSeen: false,
        setNewLayout,
        dismissAnnouncement,
      };
    },
    { name: `layout-version` },
  ),
);
